import {Injectable} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {ErrorMessageType} from '../../enums/core/error-message-type';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessagesService {

  constructor(private alertService: AlertController) { }

  /**
   *
   * @param errorMessageType
   * @param errorCode
   */
  public async showErrorMessage(errorMessageType: ErrorMessageType, errorCode: number = null): Promise<void> {
    let header = '';
    let message = '';
    let _errorCode: string = errorCode ? ' (' + errorCode.toString() + ')' : '';

    switch(errorMessageType) {
      case ErrorMessageType.Storage:
        header = 'Speicherfehler';
        message = 'Das Speichern auf ihrem Gerät ist fehlgeschlagen ' + _errorCode;
        break;
      case ErrorMessageType.Connection:
        header = 'Verbindung abgebrochen';
        message = 'Es konnte keine Verbindung zum Server aufgebaut werden ' + _errorCode;
        break;
      case ErrorMessageType.NotSynced:
        header = 'Daten nicht synchron';
        message = 'Daten sind nicht synchron und können daher nicht aktualisiert werden. Bitte den Status überprüfen. ' + _errorCode;
        break;
      case ErrorMessageType.Microphone:
        header = 'Mikrofon nicht verfügbar';
        message = 'Auf das Mikrofon konnte nicht zugegriffen werden. Bitte die Berechtigung prüfen. ' + _errorCode;
        break;
      case ErrorMessageType.RecordingInterrupted:
        header = 'Aufnahme unterbrochen';
        message = 'Die Aufnahme wurde unterbrochen, z.B. durch einen Anruf. Der bereits aufgenommene Teil wurde unter "Nicht transkribiert" gespeichert. ' + _errorCode;
        break;
      case ErrorMessageType.Unknown:
        header = 'Unbekannter Fehler';
        message = 'Ein unbekannter Fehler ist aufgetreten ' + _errorCode;
        break;
    }

    const alert = await this.alertService.create({
      header: header,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
    await alert.onDidDismiss();
  }

  /**
   *
   * @param header
   * @param message
   */
  public async showCustomErrorMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertService.create({
      header: header,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
    await alert.onDidDismiss();
  }

}
